import React from 'react';
import { BoxSelection, BoxSelectionBoxSize, IconButton } from 'wix-ui-tpa/cssVars';
import { Delete, Download, Edit, TextStyleSmall } from '@wix/wix-ui-icons-common/on-stage';
import { SignatureMode } from '../signature-types';
import { useTranslation } from '../../../contexts/translation-context';
import commonStyles from '../styles/common.scss';
import { classes } from './signature-header-wut.st.css';
export const SignatureHeaderWUT = _ref => {
  let {
    signatureMode,
    onModeChange,
    onClear,
    clearable,
    uploadEnabled,
    inputId
  } = _ref;
  const {
    t
  } = useTranslation();
  const handleModeChange = _ref2 => {
    let {
      id
    } = _ref2;
    onModeChange(id);
  };
  const modeOptions = [/*#__PURE__*/React.createElement(BoxSelection.Option, {
    className: classes.option,
    key: SignatureMode.DRAW,
    id: SignatureMode.DRAW,
    "data-hook": "draw",
    checked: signatureMode === SignatureMode.DRAW,
    "aria-label": t('field.signature.mode.draw.label'),
    size: BoxSelectionBoxSize.small
  }, /*#__PURE__*/React.createElement(Edit, {
    className: classes.icon,
    size: "24",
    "aria-hidden": true
  })), /*#__PURE__*/React.createElement(BoxSelection.Option, {
    className: classes.option,
    key: SignatureMode.TYPE,
    id: SignatureMode.TYPE,
    "data-hook": "type",
    checked: signatureMode === SignatureMode.TYPE,
    "aria-label": t('field.signature.mode.type.label')
  }, /*#__PURE__*/React.createElement(TextStyleSmall, {
    className: classes.icon,
    size: "24",
    "aria-hidden": true
  })), uploadEnabled && /*#__PURE__*/React.createElement(BoxSelection.Option, {
    className: classes.option,
    key: SignatureMode.UPLOAD,
    id: SignatureMode.UPLOAD,
    "data-hook": "upload",
    checked: signatureMode === SignatureMode.UPLOAD,
    "aria-label": t('field.signature.mode.upload.label')
  }, /*#__PURE__*/React.createElement(Download, {
    className: classes.icon,
    size: "24",
    "aria-hidden": true
  }))].filter(Boolean);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: commonStyles.visuallyHidden,
    "aria-live": "assertive"
  }, signatureMode === SignatureMode.DRAW && t('field.signature.mode.draw.description'), signatureMode === SignatureMode.TYPE && t('field.signature.mode.type.description'), signatureMode === SignatureMode.UPLOAD && t('field.signature.mode.upload.description')), /*#__PURE__*/React.createElement(BoxSelection, {
    className: classes.boxSelection,
    size: BoxSelectionBoxSize.small,
    name: "signature-mode",
    onChange: handleModeChange,
    "aria-controls": inputId
  }, modeOptions), clearable && /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClear,
    "data-hook": "clear",
    "aria-label": t('field.signature.clear-button.label'),
    "aria-controls": inputId,
    role: "button",
    icon: /*#__PURE__*/React.createElement(Delete, {
      className: classes.icon,
      "aria-hidden": "true"
    })
  }));
};
//# sourceMappingURL=signature-header-wut.js.map